import Compressor from 'compressorjs';

/**
 * @param file 文件
 * @param backType 需要返回的类型blob, file
 * @param quality 图片压缩比 0-1, 数字越小，图片压缩越小
 * @returns
 */
function compressorImage(file, quality, backType = 'file') {
    return new Promise((resolve, reject) => {
        new Compressor(file, {
            quality: quality || 0.8,
            success(result) {
                let newFile = new File([result], file.name, { type: file.type })

                if (!backType || backType == 'blob') {
                    resolve(result);
                } else if (backType == 'file') {
                    resolve(newFile);
                } else {
                    resolve(newFile);
                }
            },
            error(err){
                console.log('图片压缩失败---->>>>>', err);
                reject(err);
            }
        })
    })
};

export default compressorImage;